import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex relative" }
const _hoisted_2 = {
  key: 2,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_3 = { class: "w-full h-1" }
const _hoisted_4 = { class: "bg-brand-black flex w-full p-4 py-5 font-medium text-xl text-white border-b-4 border-brand-dark-gray max-h-80 overflow-scroll" }
const _hoisted_5 = { class: "text-sm text-white p-3" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col p-4 space-y-2"
}
const _hoisted_8 = { class: "flex flex-col space-y-2" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col p-4 space-y-2"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "animate-spin h-7 w-7 text-white m-auto",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_13 = {
  key: 1,
  class: "m-auto",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_14 = {
  key: 2,
  class: "flex flex-col p-4 space-y-2 pt-0"
}
const _hoisted_15 = { class: "flex m-auto space-x-2.5" }
const _hoisted_16 = {
  key: 0,
  class: "my-auto pt-0.5"
}

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTextarea,
  IonToolbar,
  modalController,
  toastController,
} from '@ionic/vue';
import {computed, onMounted, PropType, Ref, ref} from 'vue';
import {PostPrivacy} from "@/definitions/PostPrivacy";
import useCamera from "@/composables/useCamera";
import {CameraResultType} from "@capacitor/camera";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {FeedPostInterface} from "@/interfaces/FeedPostInterface";
import {UserInterface} from "@/interfaces/UserInterface";
import {usePremium} from "@/composables/usePremium";
import {Mentionable} from 'vue-mention'
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {CameraSource, MediaPicker} from "axiallon-capacitor-media-picker";
import {VideoEditor} from "@whiteguru/capacitor-plugin-video-editor";
import {Capacitor} from "@capacitor/core";
import InputCheckbox from "@/components/InputCheckbox.vue";
import {Filesystem} from "@capacitor/filesystem";
import {useAppSettings} from "@/composables/useAppSettings";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedNewVideoPage',
  props: {
  post: {
    type: Object as PropType<FeedPostInterface>,
    required: false
  },
  authUser: {
    type: Object as PropType<UserInterface>,
    required: true
  }
},
  setup(__props) {

const props = __props


const loading = ref(true)
const busy = ref(false)
const videoBusy = ref(false)
const posting = ref(false)
const uploadProgress = ref(0)

const postContent = ref('')
const postPhotos: Ref<string[]> = ref([])

const privacyOptions: Ref<any[]> = ref([])
const postPrivacy: Ref<PostPrivacy[]> = ref([])

const postVideo: any = ref()

onMounted(async () => {

  await reset()

  const enableNsfw = useAppSettings().settings.value.enableNsfw !== false
  if (enableNsfw) {
    privacyOptions.value.push({
      text: 'NSFW',
      description: 'Not Safe For Work 😈🍆💦',
      value: PostPrivacy.XRated,
    })
    postPrivacy.value = [PostPrivacy.XRated]
  } else {
    privacyOptions.value.push({
      text: 'Inner Circle',
      description: 'Only visible to your friends.',
      value: PostPrivacy.InnerCircle,
    })
    postPrivacy.value = [PostPrivacy.InnerCircle]
  }

  if (props.post) {
    postContent.value = props.post.data.original_content
    postPhotos.value = props.post.media.map((m) => {
      return `${m.thumbnail}`
    })
  }

  loading.value = false
})


const reset = async () => {
  postContent.value = '',
      postPhotos.value = []
  posting.value = false
  busy.value = false
}


const goBack = async () => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Discard Post',
    message: 'Are you sure you want to discard this post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: () => {
          modalController.dismiss()
          reset()
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const addPhoto = async () => {

  if (busy.value || posting.value) return

  if (!postPhotos.value.length && !videoSrc.value) return addVideo()

  try {
    const photo = await useCamera(CameraSource.Photos, CameraResultType.Base64)
    busy.value = true
    if (Object.prototype.hasOwnProperty.call(photo, 'base64String')) postPhotos.value = [`data:image/${photo.format};base64,${photo.base64String}`]
    busy.value = false
  } catch (e) {
    busy.value = false
  }

}

const removePhoto = async (index: number) => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: 'Remove Photo',
    message: 'Are you sure you want to remove this photo from the post?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: async () => {
          postPhotos.value.splice(index, 1)
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}

const canPost = computed(() => {
  if (props.post) return true
  return postPhotos.value.length > 0 && videoSrc.value
})

const postToFeed = async () => {

  if (!canPost.value) return

  try {
    posting.value = true
    const newPost = await ApiService.Feed().post(postContent.value, postPrivacy.value[0])

    await resizeVideoSrc()
    await ApiService.Feed().attachVideo(
        newPost.id,
        (progress: any) => {
          uploadProgress.value = parseInt(`${progress}`)
          console.log(progress)
        },
        postPhotos.value.length ? postPhotos.value[0] : undefined,
        postVideo.value ? postVideo.value : undefined
    )
    await reset()
    Observable.emit(ObservableEvent.FeedScrollTop)
    await modalController.dismiss()
  } catch (e: any) {

    console.log('upload error')
    console.log(e)

    posting.value = false
    if (e.status === 429) {
      return usePremium().presentPayWall({
        text: e.data.message,
        callback: () => {
          //
        }
      });
    }

    if (!e.error) {
      const toast = await toastController.create({
        message: 'Unable to process and upload video. Please try again or contact @ADMIN if the issue persists.',
        duration: 3000,
        position: 'bottom',
        color: 'danger'
      });
      await toast.present();
    }

    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }
}

const updatePost = async () => {

  if (!canPost.value) return
  if (!props.post) return
  try {
    posting.value = true
    const updatedPost = await ApiService.Feed().updatePost(props.post.id, postContent.value, PostPrivacy.XRated)
    await reset()
    await modalController.dismiss()
    Observable.emit(ObservableEvent.FeedPostChanged, updatedPost)
    posting.value = false
  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
    posting.value = false
  }
}

const loadingUsers = ref(false)
const mentionableUsers: Ref<any[]> = ref([])

const loadUsers = async (searchText = '') => {
  loadingUsers.value = true
  mentionableUsers.value = await fetchUsers(searchText)
  loadingUsers.value = false
}

const fetchUsers = async (search: string) => {
  const results = await ApiService.Search().users(search)
  return results.map((result: UserBasicInformationInterface) => {
    return {
      value: result.name,
      label: result.name
    }
  })
}

const resizeVideoSrc = async () => {

  // Transcode with progress
  const progressListener = await VideoEditor.addListener(
      'transcodeProgress',
      (info) => uploadProgress.value = info.progress * 100
  );

  const mediaFileResult = await VideoEditor.edit({
    path: videoSrc.value,
    transcode: {
      keepAspectRatio: true,
    },
  })

  await progressListener.remove();
  uploadProgress.value = 0

  const file = await fetch(Capacitor.convertFileSrc(mediaFileResult.file.path))
  postVideo.value = await file.blob()

}

const videoSrc = ref()
const addVideo = async () => {
  if (videoBusy.value) return
  videoBusy.value = true

  try {

    const video = await MediaPicker.getPhoto({
      mediaType: 'video',
      source: CameraSource.Photos,
    })

    if (video.media.length) {
      videoSrc.value = video.media[0].path

      if (!postPhotos.value.length) {
        const thumbnail = await VideoEditor.thumbnail({
          path: videoSrc.value,
          at: 1000 * 3
        })

        const thumbnailFile = await Filesystem.readFile({
          path: thumbnail.file.path
        })
        postPhotos.value = [`data:${thumbnail.file.type};base64,${thumbnailFile.data}`]
      }

      videoBusy.value = false

      // const file = await fetch(video.media[0].webPath)
      // postVideo.value = await file.blob()
    }

  } catch (e) {
    console.error('error', e);
  } finally {
    videoBusy.value = false
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { class: "!p-0 !m-0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { class: "justify-between flex w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        class: "fill-current text-white w-6 h-6 p-0.5",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512"
                      }, [
                        _createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    (!__props.post)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 0,
                          onClick: postToFeed,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Post ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (__props.post)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          onClick: updatePost,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Update ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (posting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[5] || (_cache[5] = [
                          _createElementVNode("svg", {
                            class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "h-full bg-brand-lime",
              style: _normalizeStyle({width: `${uploadProgress.value}%`})
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(Mentionable), {
              class: "w-full",
              keys: ['@'],
              items: mentionableUsers.value,
              offset: "6",
              onOpen: _cache[1] || (_cache[1] = ($event: any) => (loadUsers())),
              onSearch: _cache[2] || (_cache[2] = ($event: any) => (loadUsers($event))),
              "filtering-disabled": ""
            }, {
              "no-result": _withCtx(() => [
                _createElementVNode("div", _hoisted_5, _toDisplayString(loadingUsers.value ? 'Loading...' : 'No users found.'), 1)
              ]),
              "item-@": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_6, " @" + _toDisplayString(item.value), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(IonTextarea), {
                  "auto-grow": "",
                  autocapitalize: "on",
                  modelValue: postContent.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((postContent).value = $event)),
                  placeholder: "Spicy hot 🌶️"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["items"])
          ]),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Who can see this post?", -1)),
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(privacyOptions.value, (p, pIndex) => {
                    return (_openBlock(), _createBlock(InputCheckbox, {
                      key: pIndex,
                      name: "privacy",
                      "return-single-value": true,
                      modelValue: postPrivacy.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((postPrivacy).value = $event)),
                      option: p
                    }, null, 8, ["modelValue", "option"]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (!props.post)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "font-medium text-xl text-white" }, "Video", -1)),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(postPhotos.value, (photo, pIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: pIndex,
                      style: _normalizeStyle({
                'background-image' : `url('${photo}')`
              }),
                      class: "w-full h-96 bg-brand-dark-gray bg-cover bg-center rounded-md flex p-2"
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        onClick: ($event: any) => (removePhoto(pIndex)),
                        class: "mt-auto ml-auto",
                        width: "25",
                        height: "25",
                        viewBox: "0 0 25 25",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("rect", {
                          width: "25",
                          height: "25",
                          rx: "12.5",
                          fill: "white"
                        }, null, -1),
                        _createElementVNode("path", {
                          d: "M16.8921 7L12.5 11.3921L8.10786 7L7 8.10786L11.3921 12.5L7 16.8921L8.10786 18L12.5 13.6079L16.8921 18L18 16.8921L13.6079 12.5L18 8.10786L16.8921 7Z",
                          fill: "black"
                        }, null, -1)
                      ]))], 8, _hoisted_11))
                    ], 4))
                  }), 128)),
                  (!postPhotos.value.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: addPhoto,
                        class: "w-full h-96 bg-brand-dark-gray rounded-2xl flex"
                      }, [
                        (busy.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (!busy.value)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_13, [...(_cache[9] || (_cache[9] = [
                              _createElementVNode("path", {
                                d: "M12.5301 5.5L12.5117 19.5",
                                stroke: "white",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M5.5 12.5H19.5",
                                stroke: "white",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, null, -1)
                            ]))]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (!props.post)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("button", {
                  onClick: addVideo,
                  class: _normalizeClass([{
              'bg-brand-lime text-brand-black' : !videoSrc.value,
              'bg-brand-dark-gray text-white' : videoSrc.value
            }, "flex rounded-full w-full h-14 font-medium text-xl"])
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    (!videoBusy.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(postVideo.value ? 'Change Video' : 'Choose Video'), 1))
                      : _createCommentVNode("", true),
                    (videoBusy.value)
                      ? (_openBlock(), _createElementBlock("svg", {
                          key: 1,
                          class: _normalizeClass([{
                    'text-white': videoSrc.value,
                    'text-brand-black': !videoSrc.value,
                 }, "animate-spin m-auto h-5 w-5"]),
                          xmlns: "http://www.w3.org/2000/svg",
                          fill: "none",
                          viewBox: "0 0 24 24"
                        }, [...(_cache[11] || (_cache[11] = [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4"
                          }, null, -1),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          }, null, -1)
                        ]))], 2))
                      : _createCommentVNode("", true)
                  ])
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonToolbar))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})